module Client.Home

open Elmish
open Fable.React
open Fable.React.Props
open Shared.Domain
open Fetch
open Shared

let mutable TenantCache: TenantDisplay[] option = None

type Model =
    {
        Tenants: TenantDisplay[]
        ErrorMessage: string
    }

type Msg =
    | TenantsLoaded of TenantDisplay[]
    | FetchError of exn

let getTenantInfoCmd() =
    FetchRequest.get Urls.Tenants TenantsLoaded FetchError

let init() =
    match TenantCache with
    | None ->
        { Tenants = [||]; ErrorMessage = ""; }, getTenantInfoCmd()
    | Some t ->
        { Tenants = t; ErrorMessage = ""; }, []

let update msg model : Model * Cmd<Msg> =
    match msg with
    | TenantsLoaded tenants ->
#if DEBUG
        Browser.Dom.console.log("tenants loaded: ", tenants)
#endif
        TenantCache <- Some tenants
        { model with Tenants = tenants }, []
    | FetchError exn ->
        { model with ErrorMessage = exn.Message }, []

let view model dispatch =
    [
        yield div [ ClassName "homeBanner" ] [
            div [ ClassName "center" ] [
                h1 [] [ str "Change your tomorrow" ]                
            ]
        ]
        if model.ErrorMessage <> "" then
            yield div [ ClassName "alert alert-danger" ] [ str model.ErrorMessage ]
        yield div [ ClassName "sub" ] [
            h2 [ ClassName "title" ] [ str "Whatever your issue, it's possible to change your tomorrow to a brighter one!" ]
            p [ Style [MarginTop "40px"] ] [
                str "Wherever you are in the UK, we want to put you in touch with one of our partners. They provide help and information that could turn your life around. Don't wait - click the link below that best corresponds to your location and get started."     
            ]
            div [ ClassName "tiles"] [
                for tenant in model.Tenants do
                    let url = 
                        match tenant.LandingPage with
                        | None -> sprintf "#areas/%s" tenant.Area
                        | Some x -> sprintf "#areas/%s/pages/%s" tenant.Area x
                    yield div [ ClassName "tile" ] [
                        yield a [ Href <| url ] [
                            div [ ClassName "serviceImage" ] [
                                img [ Src (sprintf "images/%s.png" (tenant.Area)); Alt "No Image";  ] 
                            ]
                            footer [] [
                                str <| sprintf "%s (%s)" tenant.Name tenant.Location
                            ]
                        ]
                    ]
            ]
        ]
    ]